import ReferencePayment from "../features/referencePayment/ReferencePayment";
import { airlinePaymentService } from "../features/referencePayment/referencePaymentServices";

const AirlineTicketTransfer = () => (
  <ReferencePayment service={airlinePaymentService} />
);

export default AirlineTicketTransfer;
